import { RootStateType } from "../../Stores"

export const getToken = (state: RootStateType) => state.auth.user?.jwt
export const getWorkshopId = (state: RootStateType) => state.auth.user?.user.workshop?.id
export const getScheduleId = (state: RootStateType) => state.auth.user?.user.workshop?.schedule
export const getPricesId = (state: RootStateType) => state.auth.user?.user.workshop?.price
export const getRoleType = (state: RootStateType) => state.auth.user?.user.role.type